import { Routes, Route } from 'react-router-dom'
import { SetupProfilePage } from '../pages/setup/SetupProfilePage'
import { SetupPurposePage } from '../features/setupFlow/pages/setup/SetupPurposePage'
import { SetupIntentPage } from '../features/setupFlow/pages/setup/SetupIntentPage'
import { OnboardingPage } from '../features/setupFlow/pages/onboarding/OnboardingPage'
import HomeLayout from '../pages/HomeLayout'
import { OAuthCallbackPage } from '../pages/auth/OAuthCallbackPage'
import { TaskDetailWindow } from '../windows/TaskDetailWindow/TaskDetailWindow'
import { QuickAddWindow } from '../windows/QuickAddWindow/QuickAddWindow'
import { SyncProvider } from '../contexts/SyncProvider'
import { PreferencesDialogProvider } from '../contexts/PreferencesDialogContext'
import { ErrorBoundary } from '../components/common/ErrorBoundary'
import { ProtectedRoute } from './ProtectedRoute'
import { SetupRoute } from './SetupRoute'

export function WebRoutes() {
  return (
    <SyncProvider>
      <PreferencesDialogProvider>
        <ErrorBoundary variant="inline" name="WebRoutes">
          <Routes>
            <Route path="/" element={<SetupRoute />} />
            <Route path="/auth/callback" element={<OAuthCallbackPage />} />
            <Route path="/setup-profile" element={
              <ProtectedRoute><SetupProfilePage /></ProtectedRoute>
            } />
            <Route path="/setup-purpose" element={
              <ProtectedRoute><SetupPurposePage /></ProtectedRoute>
            } />
            <Route path="/setup-intent" element={
              <ProtectedRoute><SetupIntentPage /></ProtectedRoute>
            } />
            <Route path="/onboarding" element={
              <ProtectedRoute><OnboardingPage /></ProtectedRoute>
            } />
            <Route path="/home/*" element={
              <ProtectedRoute><HomeLayout /></ProtectedRoute>
            } />
            <Route path="/task-detail" element={
              <ProtectedRoute><TaskDetailWindow /></ProtectedRoute>
            } />
            <Route path="/quick-add" element={
              <ProtectedRoute><QuickAddWindow /></ProtectedRoute>
            } />
          </Routes>
        </ErrorBoundary>
      </PreferencesDialogProvider>
    </SyncProvider>
  )
}
